import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet"

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Faq, Form, Map } from "./components";
import Container from "./components/common/Container";

const Contact = ({ themeMode = "light" }: { themeMode?: string }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  // Get the route of the current page
  const route = useLocation().pathname;
  const isContact = route === "/contact";
  // console.log("route:", route)

  return (
    <Box>
      <Helmet>
        <html lang="en" />
        <title>{isContact?"AwardTool | Contact Us":"AwardTool | FAQ"} </title>
        <meta name="description" content={isContact?"You speak; we listen, listen carefully.":"Answer to the frequently Asked Questions"} />
      </Helmet>
      {isContact && <Container>
        <Grid container spacing={isMd ? 8 : 4}>
          <Grid item xs={12} md={6}>
            <Map themeMode={themeMode} />
          </Grid>
          <Grid item container xs={12} md={6} alignItems={"center"}>
            <Form />
          </Grid>
        </Grid>
      </Container>}
      <Box>
        <Container maxWidth={800}>
          <Faq />
        </Container>
      </Box>
    </Box>
  );
};

export default Contact;
